export const MAX_NUMBER_OF_SELECTED_COLUMNS = 18;
export const DEFAULT_DEBOUNCE_TIME = 300;

export const VALID_EXCEL_FILE_EXTENSIONS = ['xlsx', 'xls'];
export const MAX_EXCEL_FILE_SIZE = 5000000;

export const NULL_UUID = '00000000-0000-0000-0000-000000000000';
